import React from 'react'
import {willUseSharedCallback} from '@startlibs/core'

export const [useRegisterIsOrderingBy,getOrdering] = willUseSharedCallback()

export const isFilteringPastYearByUpload = () => getOrdering()[0] === 1

export const isUsingUploadedPastYear = (params) => {
  return (params.pastYear+"") !== "false" && (params.forceAll+"") !== "true" && isFilteringPastYearByUpload() && !params.uploadDateInit && !params.uploadDateEnd
}
export const isUsingStudyPastYear = (params) => {
  return (params.pastYear+"") !== "false" && (params.forceAll+"") !== "true" && !isFilteringPastYearByUpload() && !params.studyDateEnd && !params.studyDate
}

export const isUsingUnarchivedOnly = (params) => {
  return (params.unarchivedOnly+"") !== "false"
}

export const isUnarchivedOnlyDisabled = (params) => {
  return (params.patientId !== undefined && params.patientId !== "")
}

export const isFilteringByPatientId = (params) => {
  return (params.patientId !== undefined && params.patientId !== "")
}

export const isFilteringByAccnum = (params) => {
  return (params.accnum !== undefined && params.accnum !== "")
}

export const isFilteringByStudyuid= (params) => {
  return (params.studyuid !== undefined && params.studyuid !== "")
}

/* This function checks if any of the specific filters (patientId, accnum, or studyUid - Purview Seamless*/
export const isApplyingSpecificFilter = (params) => {
  return (
      (params.patientId !== undefined && params.patientId !== "")
      || (params.accnum !== undefined && params.accnum !== "")
      || (params.studyuid !== undefined && params.studyuid !== "")
  )
}

export const isPastYearToggleDisabled = (params) => {
  return (isFilteringPastYearByUpload() && (params.uploadDateInit || params.uploadDateEnd)) ||
    (!isFilteringPastYearByUpload() && (params.studyDateEnd || params.studyDate))
}